import React, { useCallback } from "react";
import "./Round.css";


function Round(props) {

  const changeRound = useCallback(node => {
    // console.log(node)
    if (node !== null) {
      node.classList.add("animated", "zoomInDown")
      setTimeout(()=>{
        node.classList.remove("animated", "zoomInDown")
      },4000)
    }
  }, []);
  

  return (
        <React.Fragment>
            <div id="round" ref={changeRound} className="round_text">{props.round}</div>
        </React.Fragment>
  );
}
export default Round;
